import { config } from "@/config";

export function getIllustrationSrc(id: string) {
  return `https://${config.BUCKET_NAME}.s3.eu-central-1.amazonaws.com/service/${id}.png`;
}

export function getImageUploadSrc(path: string) {
  return `https://${config.BUCKET_NAME}.s3.eu-central-1.amazonaws.com${path}`;
}
